export enum ETurn {
  None = 'None',
  Curve90 = 'Curve90',
  Curve500 = 'Curve500',
  Curve800 = 'Curve800',
  Curve500Low = 'Curve500VerticalLowProfile',
}
